import * as rnSessionStorage from './session-storage.service';

export default angular.module('rhino.components.sessionStorage', [

])
  .service(rnSessionStorage.name, rnSessionStorage.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/session-storage/session-storage.module.js